import React, { useState, useMemo } from "react";

import InternalModal from "../../commons/InternalModal";

import Table from "./Table";
import KpiComposition from "./KpiComposition";
import HealthStats from "./HealthStats";

const columnsDefinition = (teamMetric = false) => [
  {
    id: "title",
    accessorKey: "title",
    header: () => (
      <span>
        {teamMetric
          ? I18n.t("insights.page.table.team_metric.title")
          : I18n.t("insights.page.table.metric.title")}
      </span>
    ),
    cell: info => {
      const text = info.getValue() === "average"
        ? I18n.t("insights.page.table.average.title")
        : teamMetric
          ? I18n.t(`insights.kpis.${info.getValue()}`)
          : I18n.t(`insights.metrics.${info.getValue()}`);
      return (<span title={text}>{text}</span>);
    },
    enableSorting: false
  },
  {
    id: "category",
    accessorKey: "category",
    header: () => <span>{teamMetric ? "" : I18n.t("insights.page.table.category.title")}</span>,
    cell: info => <span>{info.getValue() ? I18n.t(`insights.page.table.category.${info.getValue()}`) : null}</span>,
    enableSorting: false
  },
  {
    id: "weight",
    accessorKey: "weight",
    header: () => <span>{teamMetric ? "" : I18n.t("insights.page.table.weight.title")}</span>,
    cell: info => <span>{info.getValue() ? parseFloat(info.getValue()) : null}</span>,
    enableSorting: false
  },
  {
    id: "scoring_scale",
    accessorKey: "scoring_scale",
    header: () => <span>{teamMetric ? "" : I18n.t("insights.page.table.scoring_scale.title")}</span>,
    cell: info => <span>{info.getValue() ? info.getValue() : null}</span>,
    enableSorting: false
  },
  {
    id: "subject",
    accessorKey: "subject",
    header: () => <span>{teamMetric ? "" : I18n.t("insights.page.table.subject.title")}</span>,
    cell: info => <span>{info.getValue() ? I18n.t(`insights.page.table.subject.${info.getValue()}`) : null}</span>,
    enableSorting: false
  },
  {
    id: "value",
    accessorKey: "value",
    header: () => <span>{I18n.t("insights.page.table.value.title")}</span>,
    cell: info => parseFloat(info.getValue()).toFixed(2),
    enableSorting: false
  },
  {
    id: "weighted_value",
    accessorKey: "weighted_value",
    header: () => <span>{I18n.t("insights.page.table.weighted_value.title")}</span>,
    cell: info => info.getValue() ? parseFloat(info.getValue()).toFixed(2) : null,
    enableSorting: false
  },
  {
    id: "final_value",
    accessorKey: "final_value",
    header: () => <span>{I18n.t("insights.page.table.final_value.title")}</span>,
    cell: info => info.getValue() ? parseFloat(info.getValue()).toFixed(2) : null,
    enableSorting: false
  }
];

const LeadershipHealthDetailsModal = ({ kpi, onClose }) => {

  const [metric, setMetric] = useState(null);

  const metricsColumns = useMemo(() => columnsDefinition(), []);
  const teamMetricsColumns = useMemo(() => columnsDefinition(true), []);

  const handleClose = () => {
    setMetric(null);
    onClose && onClose();
  }

  const selectMetric = (metric) => {
    if (metric?.category === "metadata" && metric?.flag) {
      setMetric(metric);
    }
  }

  const renderContent = () => kpi && (
    <div className="content">
      <div className="metrics-table">
        <Table
          columns={metricsColumns}
          data={kpi?.metrics}
          loading={false}
          onRowClick={selectMetric}
        />
        <Table
          columns={teamMetricsColumns}
          data={kpi?.team_metrics}
          loading={false}
        />
        <KpiComposition
          steps={kpi?.steps}
          result={kpi?.current_value}
        />
      </div>
      <HealthStats
        flag={metric?.flag}
        flags={metric?.flags}
      />
    </div>
  );

  return (
    <InternalModal
      type="leadership-health-details"
      isModalOpen={Boolean(kpi)}
      hideModal={handleClose}
      showModalBody={false}
      component={renderContent()}
      backdrop
    />
  );
}

export default LeadershipHealthDetailsModal;
